import React from 'react'
import { ForunsView } from './ForunsView'

export const Foruns = () => {
  return <ForunsView />
}
